import { Navigate, useLocation } from 'react-router-dom'
import type { ReactNode } from 'react'
import { useAuth, type Role } from '../lib/auth'
import { Spinner } from './ui'
import ChooseOwnPassword from './ChooseOwnPassword'

export default function ProtectedRoute({ roles, children }: { roles?: Role[]; children: ReactNode }) {
  const { user, loading } = useAuth()
  const loc = useLocation()
  if (loading) return <Spinner />
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />
  if (user.mustChangePassword) return <ChooseOwnPassword />
  if (roles && !roles.includes(user.role)) {
    // Land somewhere they can actually use rather than bouncing to a blank page.
    return <Navigate to={user.role === 'practitioner' ? '/my-month' : '/'} replace />
  }
  return <>{children}</>
}
